import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import MentorPage from '../pages/mentor/page';
import MentorsPage from '../pages/mentors/page';
import CoursesPage from '../pages/courses/page';
import CourseDetailPage from '../pages/course/page';
import CourseStudyPage from '../pages/course/study';
import ServicesPage from '../pages/services/page';
import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog/detail';
import ContactPage from '../pages/contact/page';
import LoginPage from '../pages/auth/login';
import RegisterPage from '../pages/auth/register';
import AccountPage from '../pages/account/page';
import NotFound from '../pages/NotFound';
import LegalPage from '../pages/legal/page';
import RequireAuth from '../components/auth/RequireAuth';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/mentors', element: <MentorsPage /> },
  { path: '/mentor/:mentorId', element: <MentorPage /> },
  { path: '/courses', element: <CoursesPage /> },
  { path: '/course/:courseId', element: <CourseDetailPage /> },
  { path: '/course/:courseId/study', element: <RequireAuth><CourseStudyPage /></RequireAuth> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:postId', element: <BlogDetailPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/account', element: <RequireAuth><AccountPage /></RequireAuth> },
  { path: '/legal', element: <LegalPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
